exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app{display:flex;position:relative;align-items:center;justify-content:center;width:100%;height:100%}.app .leave-behind{display:flex;position:absolute;top:0;align-items:center;justify-content:center}:-webkit-full-screen{width:100%}\n", ""]);

// exports
